module.exports = __webpack_public_path__ + "media/images/spinner/Spinner-1s-24px-819337eb8f3ff46f930c51a57190a3ed.gif";